<template>
  <div class="wrap-dashboard">
    <div class="main-content">
      <div class="wrap-content">
        <div class="title-page">Audit Trail</div>
        <div class="content">
          <table>
            <thead>
              <tr id="top">
                <th scope="col">No</th>
                <th scope="col">Created At</th>
                <th scope="col">Transaction Id</th>
                <th scope="col">Activity Type</th>
                <th scope="col">Description</th>
                <th scope="col">Status</th>
                <th scope="col">Info</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(audit, i) in auditsData" :key="i">
                <td data-label="No">{{ i + 1 }}</td>
                <td data-label="Created At">{{ audit.created_at | formatDateTime }}</td>
                <td data-label="Transaction Id">{{ audit.transaction_id }}</td>
                <td data-label="Activity Type">{{ audit.activity_type }}</td>
                <td data-label="Description">{{ audit.description }}</td>
                <td data-label="Status">{{ audit.status }}</td>
                <td data-label="Info">
                  <div>
                    <span> {{ audit.newInfo.city ? audit.newInfo.city : "-" }} {{ audit.newInfo.userIP ? audit.newInfo.userIP : "-" }}</span>
                  </div>
                </td>
                <!-- <td data-label="No">{{ i + 1 }}</td>
                <td data-label="Email">{{ user.created_at | formatDateTime }}</td>
                <td data-label="Name">{{ user.transaction_id }}</td>
                <td data-label="Username">{{ user.activity_type }}</td>
                <td data-label="Role">{{ user.description }}</td>
                <td data-label="Status">{{ user.status }}</td>
                <td data-label="Action">
                  <div>
                    <div>{{ user.newInfo.city + " - " + user.newInfo.province }}</div>
                  </div>
                </td> -->
              </tr>
            </tbody>
          </table>
          <!-- <b-pagination
            v-model="currentPage"
            :total-rows="lengthData"
            :per-page="perPage"
            @change="handlePageChange"
            aria-controls="new-table"
            first-number
            last-number
            v-show="lengthData > 10"
          ></b-pagination> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  components: {},
  data() {
    return {
      auditsData: [],
      pageOfItems: [],
      currentPage: 1,
      perPage: 10,
      lengthData: 1,
      trade_id: [],
      offset: 0,
      data: [],
      form: {
        startDate: "",
        endDate: "",
      },
      formAddUser: {
        email: "",
        username: "",
        phonenumber: "",
        fullname: "",
        password: "",
        role_id: "",
      },
      roles: [],
    };
  },
  mounted() {
    this.getData(this.currentPage);
  },
  methods: {
    handlePageChange(value) {
      this.getData(value);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    getData(value) {
      let offset = (value - 1) * this.perPage;
      console.log(offset);
      let param = this.$route.params.id;
      axios.get("/v2/clearing/audit_trail/get?activity_id=" + param).then((res) => {
        this.auditsData = res.data.data.body;
        for (let i = 0; i < this.auditsData.length; i++) {
          let newInfo;
          if (this.auditsData[i].info != undefined) {
            newInfo = JSON.parse(this.auditsData[i].info);
            this.auditsData[i].newInfo = newInfo;
          } else {
            this.auditsData[i].newInfo = "";
          }
        }
        // this.lengthData = res.data.data.count;
      });
    },
  },
  computed: {
    rows() {
      return (this.currentPage - 1) * this.perPage;
    },
  },
};
</script>

<style scoped>
/*.wrap-dashboard {
  min-height: 100vh;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}*/

.title-page {
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 40px;
}

.wrap-content {
  width: 98%;
  height: 100%;
  margin: 0 auto;
  padding: 20px 25px;
}

.content {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: end;
}

.icon-trade {
  width: 25px;
}

.footer {
  background: var(--clr-primary);
  color: white;
  padding: 20px 47px;
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  height: 62px;
}

.filter {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  font-size: 12px;
  flex-wrap: wrap;
}

.wrap-input {
  margin-bottom: 10px;
}
.label-input {
  width: 108px;
}

.input-datalist {
  border-radius: 3px;
  border: 1px solid #a5a5a5a5;
  padding: 1.5px 5px;
}

.card {
  width: 314px;
  font-size: 14px;
  border-radius: 10px;
}

.card-header {
  padding: 1rem;
}

.buyer,
.seller,
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  font-size: 12px;
  position: relative;
  left: 20px;
}

.title::before {
  content: "";
  position: absolute;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: var(--clr-scondary);
  left: -17px;
  top: 3px;
}

.buyer {
  margin-bottom: 20px;
}

.content-right {
  text-align: right;
}

.amount {
  font-weight: bold;
}

.btn-primer {
  background: var(--clr-scondary);
  border: none;
  color: #ffffff;
  padding: 5px 25px;
  border-radius: 5px;
}

.btn-primer:hover {
  background-color: var(--clr-scondary-hover);
}

.form-group label {
  font-weight: 600;
  width: 30%;
}

.form-input {
  width: 70%;
  border-radius: 5px;
  border: none;
  padding: 8px 13px;
  box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
  font-size: 14px;
}

.form-input:focus {
  border-color: var(--clr-primary);
  outline: 0;
  box-shadow: 0 1px 3px rgb(50 50 93 / 15%), 0 1px 0 rgb(0 0 0 / 2%);
}
</style>
